import { Grid } from "@mui/material";
import AcxVirtualizedSelectMulti from "components/UI/Select/AcxVirtualizedSelectMulti";
import { observer } from "mobx-react";
import React from "react";
import type ChartCardStore from "../ChartCardStore";

type TopicsControlProps = {
    store: ChartCardStore;
};

const TopicsControl = observer(({ store }: TopicsControlProps) => {
    const optionsLoading = store.isRefreshing && store.topics.length === 0;

    return (
        <Grid container item xs={4}>
            <AcxVirtualizedSelectMulti
                options={store.topics}
                id={`topic-select-${store.id}`}
                onApply={(ids) => {
                    store.setSelectedId("topics", ids);
                    store.handleSelectionChange();
                }}
                itemName="Theme"
                defaultSelectedIds={
                    store.selectedIds["topics"] as string[] | undefined
                }
                labelField="topicLabel"
                idField="id"
                maxSelectionCount={store.getMaxSelection()}
                isLoading={optionsLoading}
                enableCompactLayout
                disabled={store.isReadOnly}
                disabledAppearance="readOnly"
            />
        </Grid>
    );
});

export default TopicsControl;
